// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.typed-element{display:flex;align-items:center}.typed-element .typed-cursor{opacity:1;-webkit-animation:typedjsBlink .7s infinite;animation:typedjsBlink .7s infinite}@-webkit-keyframes typedjsBlink{50%{opacity:0}}@keyframes typedjsBlink{50%{opacity:0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
